﻿export function setupRetailNewCarFinanceManufacturer() {
    $(document).on('change', '[data-retail-new-car-finance-manufacturer]', goToManufacturer)
}

function goToManufacturer(event) {
    event.preventDefault();
    const val = $(event.target).val();
    if (val) {
        window.location.href = val;
    }
}